export class DocumentChartsModel {
    documentStatusChart: any = {};
    documentStatusChartPeriodWise: any = {};
}